import { TButtonSize } from '@core/types/button';

export interface ISideIcon {
  name: string;
  size: number;
}

export interface IButtonIcon {
  name: string;
  position: string;
}

export interface IButton {
  link: string;
  text: string;
  appearance?: string;
  icon?: IButtonIcon;
  sideIcon?: ISideIcon;
  size?: TButtonSize;
}

export interface IButtonConfig {
  breakpoint: EnButtonBreakpoint | EnButtonBreakpoint[] | undefined;
  reSize: TButtonSize;
}

export enum EnButtonBreakpoint {
  'desktopLarge' = 'desktopLarge',
  'desktopMedium' = 'desktopMedium',
  'desktopSmall' = 'desktopSmall',
  'tablet' = 'tablet',
  'mobile' = 'mobile',
  'mobileLarge' = 'mobileLarge',
}
